import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import type { AppDispatch, RootState } from "@/store"
import { selectCurrentOrganizationId } from "@/modules/organizations/store/organizationSlice"
import {
  fetchSageVipConnection,
  upsertSageVipConnection,
  deleteSageVipConnection,
  selectSageVipConnection,
  selectSageVipIsLoading,
  selectSageVipIsSubmitting,
  selectSageVipIsDeleting,
  selectSageVipError,
  selectSageVipIsSuccess,
} from "../store/sageVipConnectorSlice"
import type { SageVipUpsertRequestDto } from "../dtos/SageVipConnectDto"

export function useSageVipConnector() {
  const dispatch = useDispatch<AppDispatch>()
  const organizationId = useSelector((s: RootState) =>
    selectCurrentOrganizationId(s),
  )

  const connection = useSelector((s: RootState) => selectSageVipConnection(s))
  const isLoading = useSelector((s: RootState) => selectSageVipIsLoading(s))
  const isSubmitting = useSelector((s: RootState) =>
    selectSageVipIsSubmitting(s),
  )
  const isDeleting = useSelector((s: RootState) => selectSageVipIsDeleting(s))
  const error = useSelector((s: RootState) => selectSageVipError(s))
  const isSuccess = useSelector((s: RootState) => selectSageVipIsSuccess(s))

  useEffect(() => {
    if (organizationId) {
      dispatch(fetchSageVipConnection(organizationId))
    }
  }, [dispatch, organizationId])

  const upsert = async (dto: SageVipUpsertRequestDto) => {
    if (organizationId) {
      await dispatch(upsertSageVipConnection({ organizationId, dto }))
    }
  }

  const disconnect = async () => {
    if (organizationId) {
      await dispatch(deleteSageVipConnection(organizationId))
    }
  }

  return {
    connection,
    isLoading,
    isSubmitting,
    isDeleting,
    error,
    isSuccess,
    upsert,
    disconnect,
  }
}
